module.exports = __webpack_public_path__ + "static/media/icon_select1.1de1a221.svg";